import { env } from './env';

export const ERROR_MESSAGE_LOCATION =
  'https://gitlab.glyco.info/glycosmos/glycombgroup/document/-/blob/master/forUiDocument/error_messages.yaml' as const;

export const HOST_NAME = {
  PROD: 'glytoucan.org',
  BETA: 'beta.glytoucan.org',
  ALPHA: 'alpha.glytoucan.org',
} as const;

export const GOOGLE_SIGNIN_URL = {
  PROD: 'https://accounts.google.com/o/oauth2/v2/auth?client_id=144546288829-o7vr36n5s7it71pi6tandfmsqteq38p3.apps.googleusercontent.com&response_type=code&scope=openid%20email&redirect_uri=https%3A%2F%2Fglytoucan.org%2Fauth%2Fgoogle',
  BETA: 'https://accounts.google.com/o/oauth2/v2/auth?client_id=144546288829-o7vr36n5s7it71pi6tandfmsqteq38p3.apps.googleusercontent.com&response_type=code&scope=openid%20email&redirect_uri=https%3A%2F%2Fbeta.glytoucan.org%2Fauth%2Fgoogle',
  ALPHA:
    'https://accounts.google.com/o/oauth2/v2/auth?client_id=144546288829-o7vr36n5s7it71pi6tandfmsqteq38p3.apps.googleusercontent.com&response_type=code&scope=openid%20email&redirect_uri=https%3A%2F%2Falpha.glytoucan.org%2Fauth%2Fgoogle',
} as const;

export const ORCID_SIGNIN_URL = {
  PROD: 'https://orcid.org/oauth/authorize?client_id=APP-81G9PB8KMSHICGW4&response_type=code&scope=/authenticate&redirect_uri=https%3A//glytoucan.org/auth/orcid',
  BETA: 'https://orcid.org/oauth/authorize?client_id=APP-81G9PB8KMSHICGW4&response_type=code&scope=/authenticate&redirect_uri=https%3A//beta.glytoucan.org/auth/orcid',
  ALPHA:
    'https://orcid.org/oauth/authorize?client_id=APP-81G9PB8KMSHICGW4&response_type=code&scope=/authenticate&redirect_uri=https%3A//alpha.glytoucan.org/auth/orcid',
} as const;

export const GlyTouCan_API = {
  ACCESSION_COUNT: '/api/entry/count',
  ACCESSION_ARCHETYPE_COUNT: '/api/archetype/count',
  ACCESSIONS_LIST: '/api/entry/list',
  SEARCH_TEXT: '/api/search/data',
  ENTRY_DATA: (accNum: string) => `/api/entry/data/${accNum}`,
  ARCHETYPE_DATA: (accNum: string) => `/api/archetype/list/${accNum}`,
  FEEDBACK: 'https://forms.gle/WrR6DxerzezutXzV8',
  TOKEN_EXPIRE_TIME: '/api/expiration-millis',
  LOGOUT: '/api/logout',

  USER_PROFILE: '/auth/api/user/profile',
  SUBMISSIONS_LIST: '/auth/api/submission/list/wurcs',
  SUBMISSIONS_LIST_GLYCOCT: '/auth/api/submission/list/glycoct',
  SUBMISSION_COUNT: '/auth/api/submission/count/wurcs',
  SUBMISSION_COUNT_GLYCOCT: '/auth/api/submission/count/glycoct',
  SUBMISSION_DATA: (format: string, submissionNumber: string) =>
    `/auth/api/submission/data/${format}/${submissionNumber}`,
  SUBMISSION_RESULTS: (submissionNumber: string) =>
    `/auth/api/submission/results/${submissionNumber}`,
  API_KEY_UPDATE: '/auth/api/update-key',
  REGISTRATION_REQUEST: '/auth/api/submission',
  INPUT_VALIDATION: '/api/input-validation',
};

export const GLYCOMB_API = {
  ACCESSION_COUNT: '/api/accessions-count',
  INPUT_VALIDATION: '/api/input-validation',
  SEARCH_TEXT: '/api/search-text',
  ENTRY_DATA: (accNum: string) => `/api/get-entry/${accNum}`,
  SEQUENCE_DATA: (uuid: string) => `/api/get-sequence/${uuid}`,
  ACCESSIONS_LIST: '/api/accessions-list',
  TOKEN_EXPIRE_TIME: '/api/expiration-millis',
  LOGOUT: '/api/logout',

  REGISTRATION_REQUEST: '/auth/api/registration-request',
  USER_PROFILE: '/auth/api/user-profile',
  SECONDARY_MAIL_UPDATE: '/auth/api/user-update',
  SUBMISSIONS_LIST: '/auth/api/submissions-list',
  SUBMISSION_DATA: (submissionNumber: string) =>
    `/auth/api/get-entry/${submissionNumber}`,
  PUBLISH_SUBMISSION: (uuid: string) => `/auth/api/publish-entry/${uuid}`,
  PUBLISH_SUBMISSIONS: '/auth/api/publish-entry',
} as const;

export const GLYCOSMOS_API = {
  SNFG_GLYCAN_IMAGE: (gtcId: string) =>
    `https://image.glycosmos.org/snfg/png/${gtcId}`,
  WURCS2IMAGE_GLYCAN_IMAGE: (gtcId: string) =>
    `https://api.glycosmos.org/wurcs2image/${env.WURCS2IMAGE_VERSION}/png/json/${gtcId}`,
  UPID2SEQ_PROTEIN_SEQUENCE: 'https://api.glycosmos.org/upid2seq',
  GRAPHIC: 'https://glycanbuilder2web.glycosmos.org/',
  GLYCOCT2WURCS:
    'https://api.glycosmos.org/glycanformatconverter/2.10.4/glycoct2wurcs',
  WURCS2WURCS:
    'https://api.glycosmos.org/glycanformatconverter/2.10.4/wurcs2wurcs',
  PARTNER: (accNum: string) =>
    `https://sparqlist.glytoucan.org/sparqlist/api/gtc_external_id?accNum=${accNum}`,
} as const;

export const MISC_API = {} as const;
